import React, { useMemo, useCallback } from 'react'
import { TableRow, TableCell, TableBody, Skeleton } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles({
  skeletonCell: {
    borderRadius: 28
  }
})

export type TableBodyPlaceholderProps = {
  columns: number,
  rows: number
}

const getRandomNumberFromRange = (min: number, max: number) => {
  return Math.random() * (max - min) + min
}

export const TableBodyPlaceholder: React.FC<TableBodyPlaceholderProps> = (props) => {
  const { columns, rows } = props
  const classes = useStyles()

  const generateRowContent = useCallback((columns: number): JSX.Element[] => {
    const rowContent: JSX.Element[] = []
    for (let i = 0; i < columns; i++) {
      rowContent.push(<TableCell key={`rowContent_${i}`}><Skeleton animation='wave' className={classes.skeletonCell} height={20} width={`${getRandomNumberFromRange(30, 70)}%`} /></TableCell>)
    }
    return rowContent
  }, [classes.skeletonCell])

  const generateRowLoaders = useCallback((columns: number, numberOfRows: number): JSX.Element[] => {
    const rows: JSX.Element[] = []
    for (let i = 0; i < numberOfRows; i++) {
      const rowContent = generateRowContent(columns)
      rows.push(<TableRow key={`row_${i}`}>{rowContent}</TableRow>)
    }
    return rows
  }, [generateRowContent])

  const rowLoaders = useMemo(() => {
    return generateRowLoaders(columns, rows)
  }, [columns, generateRowLoaders, rows])

  return (
    <TableBody>
      {rowLoaders}
    </TableBody>
  )
}
